$(document).ready(function () {
    const main_slider = new Swiper('.main-slider .swiper-container', {
        loop: true,
        autoHeight: true,
        autoplay: {
            delay: 10000,
        },
        speed: 1000,
        navigation: {
            nextEl: '.main-slider .swiper-button-next',
            prevEl: '.main-slider .swiper-button-prev',
        },
        pagination: {
            el: '.main-slider .swiper-pagination',
            clickable: true,
        },
    });

    $(".main-slider .swiper-pagination").css('top', ($(".main-slider .swiper-slide-active .item .image").height() - 25));
    main_slider.on('slideChangeTransitionStart', function () {
        $(".main-slider .swiper-pagination").css('top', ($(".main-slider .swiper-slide-active .item .image").height() - 25));
    });

    const afisha_slider = new Swiper('.afisha-slider .swiper-container', {
        loop: true,
        autoHeight: true,
        slidesPerView: 'auto',
        spaceBetween: 10,
        simulateTouch: false,
        navigation: {
            nextEl: '.afisha-slider .swiper-button-next',
            prevEl: '.afisha-slider .swiper-button-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1620: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        },
    });

    const news_slider = new Swiper('.news-slider .swiper-container', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 5,
        simulateTouch: false,
        navigation: {
            nextEl: '.news-slider .swiper-button-next',
            prevEl: '.news-slider .swiper-button-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
        },
    });

    const books_slider = new Swiper('.books-slider .swiper-container', {
        loop: true,
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 10,
        simulateTouch: false,
        navigation: {
            nextEl: '.books-slider .swiper-button-next',
            prevEl: '.books-slider .swiper-button-prev',
        },
        breakpoints: {
            375: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1620: {
                slidesPerView: 5,
                spaceBetween: 30,
            },
        },
    });

    const partners_slider = new Swiper('.partners-slider .swiper-container', {
        loop: true,
        autoHeight: false,
        slidesPerView: 'auto',
        spaceBetween: 10,
        navigation: {
            nextEl: '.partners-slider .swiper-button-next',
            prevEl: '.partners-slider .swiper-button-prev',
        },
        breakpoints: {
            480: {
                autoHeight: true,
                slidesPerView: 2,
                spaceBetween: 30,
            },
            768: {
                autoHeight: true,
                slidesPerView: 4,
                spaceBetween: 30,
            },
            1620: {
                autoHeight: true,
                slidesPerView: 6,
                spaceBetween: 30,
            },
        },
    });


    const images_slider = new Swiper('.images-slider .swiper-container', {
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 15,
        simulateTouch: false,
        autoHeight: true,
        navigation: {
            nextEl: '.images-slider .swiper-button-next',
            prevEl: '.images-slider .swiper-button-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1620: {
                slidesPerView: 4,
            },
        },
    });

    const sections_slider = new Swiper('.sections-slider .swiper-container', {
        loop: true,
        autoHeight: true,
        slidesPerView: 'auto',
        spaceBetween: 10,
        simulateTouch: false,
        navigation: {
            nextEl: '.sections-slider .swiper-button-next',
            prevEl: '.sections-slider .swiper-button-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
            1620: {
                slidesPerView: 5,
                spaceBetween: 30,
            },
        },
    });

    $(".show-search").on('click', function () {
        $(".search-form").toggleClass('active');
    });

    $(document).on('click', function (event) {
        var $target = $(event.target);
        if ($target.closest('.search').length === 0) {
            $('.search .search-form').removeClass('active');
        }
    });

    var menuButton = $('.menu-button');
    menuButton.on('click', function () {
        $(this).toggleClass('cross');
        $(".top-menu").toggleClass('open');
        $(".menu-layout").toggleClass('open');
    });
    $(".menu-layout").on('click', function (e) {
        menuButton.removeClass('cross');
        $(".top-menu").removeClass('open');
        $(".menu-layout").removeClass('open');
    });
    $(".dropdown-menu-arrow").on('click', function (e) {
        e.preventDefault();
        $(this).parents(".dropdown-menu").toggleClass('open');
    });
    $('[data-fancybox]').fancybox({
        loop: true,
    });

    $.bvi({
        'bvi_target': '.blind-mode', // Класс ссылки включения плагина
        "bvi_theme": "white", // Цвет сайта
        "bvi_font": "arial", // Шрифт
        "bvi_font_size": 20, // Размер шрифта
        "bvi_letter_spacing": "normal", // Межбуквенный интервал
        "bvi_line_height": "normal", // Междустрочный интервал
        "bvi_images": true, // Изображения
        "bvi_reload": false, // Перезагрузка страницы при выключении плагина
        "bvi_fixed": false, // Фиксирование панели для слабовидящих вверху страницы
        "bvi_tts": false, // Синтез речи
        "bvi_flash_iframe": true, // Встроенные элементы (видео, карты и тд.)
        "bvi_hide": false // Скрывает панель для слабовидящих и показывает иконку панели.
    });

});

